import axiosService from '@/api/common/axios'
import axios from 'axios'

const api = {
  searchMapInfoWindow: function (data) {
    return axiosService.post('/portal/data/map/infoWindow', { data: data })
  },

  searchLocationBoard: function (data) {
    return axiosService.post('/portal/data/board/location', data)
  },

  searchColumnChatBoard: function (data) {
    return axiosService.post('/portal/data/board/columnChart', data)
  },

  searchGridBoard: function (data) {
    return axiosService.post('/portal/data/board/grid', data)
  },

  searchKorea: function () {
    return axios.get('/data/Korea.json')
  },
  searchSiDo: function (admCd) {
    return axios.get('/data/sido_' + admCd + '.json')
  }

}

export default api
